<div class="qa-codes">
	<app-rc-qa-codes [rules]="rules"></app-rc-qa-codes>
</div>
<div class="qa-content">
	<div class="align-wrap">
		<div class="transpose-lock">
			<div class="cell-item" title="Left-Right Transpose Lock">
				<input type="checkbox" name="transposeCheckALl" [(ngModel)]="transposeCheckALl" (ngModelChange)="toggleTransposeCheckAll()">
			</div>
			<div class="cell-item" *ngFor="let col of leftCols; let idx = index">
				<input type="checkbox" name="transposeCheck-{{idx}}" [(ngModel)]="col.isTransposable">
			</div>
		</div>
		<div class="col-labels">
			<div class="cell-item"></div>
			<div class="cell-item" *ngFor="let col of leftCols" appHtmlTooltip [tooltip]="col.htmlTooltip">
				<label>{{col.neutralLabel}}</label>
			</div>
			<div class="cell-item" *ngFor="let col of metricsInfo.leftCols" appHtmlTooltip [tooltip]="col.htmlTooltip">
				<label>{{col.neutralLabel}}</label>
			</div>

			<div class="cell-item cell-button" title="Add an exception">
				<!-- <app-button-except (click)="clickExcept()"></app-button-except> -->
			</div>
		</div>
		<div class="road-left">
			<div class="cell-item">
				Left
			</div>

			<div class="cell-item" *ngFor="let col of leftCols; let idx = index;">
				<app-rc-cell [column]="col" [rcRecordItem]="centerline" [domain]="domainsByColumn[col.prop]" (edit)="onEditCell($event.col)"></app-rc-cell>
				<app-button-switch *ngIf="idx===0" class="switch-from-to-measure switch-from-to-measure-left" [isUpDown]="true" (click)="switchUpDown('left')"></app-button-switch>            
				<!-- <input name="col-left-{{idx}}" [(ngModel)]="centerline.props[col.prop]"> -->
			</div>
			<div class="cell-item" *ngFor="let col of metricsInfo.leftCols;">
				<div>{{metricsInfo.props[col.prop]}}</div>
			</div>

			<!-- <div class="cell-item cell-button">
				<app-button-switch [isUpDown]="true" (click)="switchUpDown('left')"></app-button-switch>            
			</div> -->
		</div>
		<div class="road-draw">
			<div class="cell-item cell-button">
				<app-button-switch title="Switch Left and Right Values" (click)="switchLeftRight()"></app-button-switch>
			</div>
			<!-- <div class="cell-item cell-button">
				<app-button-flip-road title="Reverse direction" (click)="flipRoad()"></app-button-flip-road>

			</div> -->

			
			<!-- <div class="road-draw-inner">
				<div class="arrow-wrap arrow-vertical" [ngClass]="{'flip-road': isFlipRoad}">
					<div class="arrow-point"></div>
					<div class="arrow-line"></div>
				</div>
				<app-button-switch title="Reverse direction" [isUpDown]="true" (click)="flipRoad()"></app-button-switch>            
			</div>

			<div class="cell-item" *ngFor="let col of metricsInfo.leftCols; let idx = index;">
			</div>
			<div class="cell-item cell-button">
				<app-button-switch (click)="switchLeftRight()"></app-button-switch>
			</div> -->
		</div>
		<div class="road-right">
			<div class="cell-item">
				Right
			</div>
			<div class="cell-item" *ngFor="let col of rightCols; let idx = index;">
				<app-rc-cell [column]="col" [rcRecordItem]="centerline" [domain]="domainsByColumn[col.prop]" (edit)="onEditCell($event.col)"></app-rc-cell>
				<app-button-switch *ngIf="idx===0" class="switch-from-to-measure switch-from-to-measure-right" [isUpDown]="true" (click)="switchUpDown('right')"></app-button-switch>   
			</div>
			<div class="cell-item" *ngFor="let col of metricsInfo.rightCols;">
				<div>{{metricsInfo.props[col.prop]}}</div>
			</div>

			<!-- <div class="cell-item cell-button">
				<app-button-switch [isUpDown]="true" (click)="switchUpDown('right')"></app-button-switch>            
			</div> -->
		</div>
	</div>
</div>